import Alert from 'react-bootstrap/Alert';
import { useTranslation } from 'react-i18next';

interface ErrorMessageProps {
  text: string;
  description?: string;
}

export default function ErrorMessage(props: ErrorMessageProps) {
  const { t } = useTranslation();

  return (
    <Alert variant="danger" className="mt-3">
      {t(props.text)}
      {props.description && ` ${props.description}`}
    </Alert>
  );
}
